import { useNavigate } from 'react-router-dom';
import { apis } from 'apis/apis';
import useToast from 'hooks/useToast';
import { useQuery } from 'react-query';
import { IErrRes } from 'type/db';
import { getCookie, removeCookie, setCookie } from 'utils/cookies';

/** imms 워크스페이스 코드 가져오기 */
export const useGetWorkspaceCodeQuery = <T>(options?: T) => {
	const toast = useToast();
	const navigate = useNavigate();
	return useQuery(['enterprise_code'], apis.getWorkspaceCode, {
		retry: 0,
		onError: (err: IErrRes) => {
			console.log(err);
			if (err.resultCode === 'token_not_valid') {
				toast('로그인 기간이 만료되었습니다.', false, true);
				removeCookie('imms_access_token', { path: '/' });
				removeCookie('imms_workspace_code', { path: '/' });
				navigate('/imms/login', { replace: true });
			}
		},
		onSuccess: (data) => {
			const code_cookie = getCookie('imms_workspace_code');
			if (!code_cookie || code_cookie !== data.code)
				setCookie('imms_workspace_code', data.code);
		},
		enabled:
			getCookie('imms_access_token') && getCookie('imms_access_token') !== ''
				? true
				: false,
		staleTime: 1000 * 60 * 5,
		cacheTime: Infinity,
		...options,
	});
};

/** imms 워크스페이스 코드 가져오기 */
export const useGetUserDataQuery = <T>(options?: T) => {
	const toast = useToast();
	const navigate = useNavigate();
	return useQuery(['user'], apis.getUserData, {
		retry: 0,
		onError: (err: IErrRes) => {
			console.log(err);
			if (err.resultCode === 'token_not_valid') {
				toast('로그인 기간이 만료되었습니다.', false, true);
				removeCookie('imms_access_token', { path: '/' });
				removeCookie('imms_workspace_code', { path: '/' });
				navigate('/imms/login', { replace: true });
			}
		},
		enabled:
			getCookie('imms_access_token') && getCookie('imms_access_token') !== ''
				? true
				: false,
		staleTime: 1000 * 60 * 5,
		cacheTime: Infinity,
		...options,
	});
};
